import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { DatabaseMgmt } from "../../../../services/DatabaseService/DatabaseMgmt";

import { BreadCrumb } from "../../component/BreadCrumb";
import Usermgmt from "../../../../services/UserServices/Usermgmt";
import { Triangle } from "react-loader-spinner";
import CustomDataTable from "./../../../../Components/CustomTable/CustomTable";
import {
  formatDate,
  formatDateTime,
} from "./../../../../Components/Common/FormatDate";
import { wrap } from "lodash";
import { Link, useNavigate } from "react-router-dom";
import Userform from "./Userform";

export default function Usermanagement() {
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState();
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const toggleUserForm = () => {
    setIsUserFormOpen(!isUserFormOpen);
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const result = await Usermgmt.getUser();
      setDataList(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await Usermgmt.getUser();
        setDataList(result);
      } catch (error) {
        console.error("Failed to load data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log(dataList);
  const [filterText, setFilterText] = useState("");
  const [addModal, setAddModal] = useState(false);

  // const handleUserClick = (id) => {
  //     navigate(`/user-management/details/${id}`);
  //   };

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = dataList.filter(
    (item) =>
      (item.username?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ) ||
      (item.email?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || "",
      ),
  );

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "70px",
    },
    {
      name: "Name",
      selector: (row) => row.username,
      cell: (row) => <Link to={`/User/${row?.id}`}>{row.username}</Link>,
      sortable: true,
      width: "16%",
    },
    {
      name: "Email",
      width: "20%",
      // minWidth: "150px",
      wrap: true,
      selector: (row) => <span title={row.email}>{row.email}</span>,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row.mobile,
      sortable: true,
      width: "15%",
    },
    {
      name: "Registered Date",
      width: "18%",
      selector: (row) => (
        <span title={formatDate(row.regDate)}>{formatDate(row.regDate)}</span>
      ),
      sortable: true,
    },

    {
      name: "Status",
      width: "9%",
      selector: (row) => (
        <span className={`badge ${row.status ? "bg-success" : "bg-danger"}`}>
          {row.status ? "True" : "False"}
        </span>
      ),
    },
    {
      name: "Roles",
      width: "15%",
      selector: (row) => {
        const roles = Array.isArray(row.roles) ? row.roles : [];
        return (
          <div>
            {roles.length > 0 ? (
              roles.map((role, idx) => (
                <span key={idx} className="badge bg-info me-1">
                  {role}
                </span>
              ))
            ) : (
              <span className="text-muted">No roles</span>
            )}
          </div>
        );
      },
    },
    {
      // name: 'Actions',
      // cell: (row) => (
      //   <Dropdown
      //     isOpen={row.dropdownOpen || false}
      //     toggle={() => {
      //       setDataList((prev) =>
      //         prev.map((item) =>
      //           item.id === row.id
      //             ? { ...item, dropdownOpen: !item.dropdownOpen }
      //             : { ...item, dropdownOpen: false }
      //         )
      //       );
      //     }}
      //   >
      //     <DropdownToggle color="primary" outline className="btn-sm">
      //       <i className="ri-more-2-fill"></i>
      //     </DropdownToggle>
      //     <DropdownMenu end>
      //       <DropdownItem onClick={() => setAddModal(true)}>
      //         <i className="ri-edit-line text-warning me-2"></i> Edit
      //       </DropdownItem>
      //       <DropdownItem>
      //         <i className="ri-delete-bin-5-line text-danger me-2"></i> Delete
      //       </DropdownItem>
      //     </DropdownMenu>
      //   </Dropdown>
      // )
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setSelectedUser(row);
              setSelectedId(row.id);
              setIsUserFormOpen(true);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            // onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="User" pageTitle="Users" />
      </div>
      <Row>
        <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by username and email"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => {
              setSelectedUser(null);
              setSelectedId(null);
              setIsUserFormOpen(true);
            }}
          >
            + Add User
          </button>
        </Col>
        <Col
          md={4}
          xs={2}
          className="d-flex d-lg-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success"
            onClick={() => {
              setSelectedUser(null);
              setSelectedId(null);
              setIsUserFormOpen(true);
            }}
          >
            +
          </button>
        </Col>
      </Row>

      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>ID:</strong> {item.id}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Name:</strong> {item.username}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Email:</strong> {item.email}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Registered Date:</strong> {item.regDate}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Roles:</strong>{" "}
                      {Array.isArray(item.roles) && item.roles.length > 0 ? (
                        item.roles.map((role, idx) => (
                          <span key={idx} className="badge bg-info ms-1">
                            {role}
                          </span>
                        ))
                      ) : (
                        <span className="text-muted">No roles</span>
                      )}
                    </h6>
                    {/* <h6 className="mb-2">
                      <strong>Description:</strong> {item.description}
                    </h6> */}
                    {item.status ? (
                      <button
                        className="btn btn-success px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        Active
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        InActive
                      </button>
                    )}
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((userItem) =>
                              userItem.id === item.id
                                ? {
                                    ...userItem,
                                    dropdownOpen: !userItem.dropdownOpen,
                                  }
                                : { ...userItem, dropdownOpen: false },
                            ),
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setSelectedUser(item);
                              setSelectedId(item.id);
                              setIsUserFormOpen(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}

          <Userform
            isOpen={isUserFormOpen}
            toggle={toggleUserForm}
            id={selectedId}
            selectedItem={selectedUser}
            onSuccess={fetchUsers}
          />
        </>
      )}
    </div>
  );
}
